import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import ReportPlayerErrorModal from './ReportPlayerErrorModal';
export default class PlayerDirectoryCard extends Component {
  view() {
    var _player$ratingStats, _player$ratingStats2;
    const player = this.attrs.player;
    const isCoach = player.entityType === 'coach';
    const posKey = isCoach ? 'coach' : player.positionNormalized || 'default';
    const positionTrans = app.translator.trans("bizkaitarra-lineup.forum.players_directory.positions.".concat(posKey));
    return m("div", {
      className: "PlayerCard PlayerCard--directory ".concat(player.isBirthdayToday ? 'PlayerCard--isBirthdayToday' : '')
    }, m("div", {
      className: "PlayerCard-header"
    }, m("div", {
      className: "PlayerCard-avatar-wrap"
    }, player.photoUrl ? m("img", {
      src: player.photoUrl,
      alt: player.name,
      className: "PlayerCard-avatar",
      loading: "lazy"
    }) : m("div", {
      className: "PlayerCard-avatar-placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), !isCoach && player.number && m("span", {
      className: "PlayerCard-dorsal"
    }, "#", player.number)), m("div", {
      className: "PlayerCard-identity"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.player-profile', {
        slug: player.slug
      }),
      className: "PlayerCard-name",
      title: player.name
    }, player.name), m("div", {
      className: "PlayerCard-badges"
    }, isCoach ? m("span", {
      className: "PlayerCard-positionBadge PlayerCard-positionBadge--coach"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.coach')) : player.position && m("span", {
      className: "PlayerCard-positionBadge PlayerCard-positionBadge--".concat(posKey)
    }, positionTrans !== "bizkaitarra-lineup.forum.players_directory.positions.".concat(posKey) ? positionTrans : player.position), player.isBirthdayToday && m("span", {
      className: "PlayerCard-birthdayBadge PlayerCard-birthdayBadge--today"
    }, "\uD83C\uDF82 ", app.translator.trans('bizkaitarra-lineup.forum.players_directory.badge_birthday_today'))))), m("div", {
      className: "UserDirectory-statsGrid PlayerCard-statsGrid"
    }, m("div", {
      className: "UserDirectory-statBox PlayerCard-statBox PlayerCard-statBox--birthday",
      title: player.age !== null ? "".concat(player.birthDateFormatted || player.birthDate || '', " (").concat(player.age, " ").concat(app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_years_abbr'), ")") : ''
    }, m("i", {
      className: "fas fa-calendar-alt UserDirectory-statIcon"
    }), m("div", {
      className: "UserDirectory-statContent"
    }, m("span", {
      className: "UserDirectory-statCount"
    }, player.birthDateFormatted || (player.birthDate ? player.birthDate.split('-').reverse().join('/') : '-')), m("span", {
      className: "UserDirectory-statLabel"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_birth_date')))), m("div", {
      className: "UserDirectory-statBox PlayerCard-statBox PlayerCard-statBox--rating",
      title: app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_rating_tooltip')
    }, m("i", {
      className: "fas fa-star UserDirectory-statIcon"
    }), m("div", {
      className: "UserDirectory-statContent"
    }, m("span", {
      className: "UserDirectory-statCount"
    }, (_player$ratingStats = player.ratingStats) != null && _player$ratingStats.average ? Number(player.ratingStats.average).toFixed(2) : '-'), m("span", {
      className: "UserDirectory-statLabel"
    }, (_player$ratingStats2 = player.ratingStats) != null && _player$ratingStats2.matchesCount ? app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_matches', {
      count: player.ratingStats.matchesCount
    }) : app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_no_ratings'))))), m("div", {
      className: "UserDirectory-actions PlayerCard-actions"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.player-profile', {
        slug: player.slug
      }),
      className: "Button Button--link UserDirectory-actionBtn PlayerCard-actionBtn PlayerCard-actionBtn--profile"
    }, m("i", {
      className: "fas fa-id-card"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_profile'))), player.birthdaySlug && m(Link, {
      href: app.route('bizkaitarra-lineup.birthday', {
        slug: player.birthdaySlug
      }),
      className: "Button Button--link UserDirectory-actionBtn PlayerCard-actionBtn PlayerCard-actionBtn--wishes ".concat(player.isBirthdayToday ? 'is-today' : ''),
      title: player.isBirthdayToday ? app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_wish_today_tooltip') : app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_wishes_tooltip')
    }, m("i", {
      className: "fas fa-gift"
    }), m("span", null, player.isBirthdayToday ? app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_wish_today') : app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_wishes'))), app.session.user && m(Button, {
      className: "Button Button--link UserDirectory-actionBtn PlayerCard-actionBtn PlayerCard-actionBtn--report",
      title: app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_report_error_tooltip'),
      onclick: () => {
        app.modal.show(ReportPlayerErrorModal, {
          player
        });
      }
    }, m("i", {
      className: "fas fa-flag"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_report_error')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayerDirectoryCard', PlayerDirectoryCard);